import script from "./DiscoveryLevel.vue?vue&type=script&setup=true&lang=js"
export * from "./DiscoveryLevel.vue?vue&type=script&setup=true&lang=js"

import "./DiscoveryLevel.vue?vue&type=style&index=0&id=ca8eb9f8&scoped=true&lang=scss"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-ca8eb9f8"]])

export default __exports__